import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button, Select, MenuItem} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography'; 
//import TagsOptions from '../components/TagsOptions';
import AutocompleteTreeviewTemp from '../components/AutocompleteTreeviewTemp';
import AutocompleteTT from '../components/AutocompleteTT';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);
  
  const [templateTitle, setTemplateTitle] = React.useState("");
  const [treeviewTemplateId, setTreeviewTemplateId] = React.useState(0);
  const [treeviewTemplateTitle, setTreeviewTemplateTitle] = React.useState("");
  // const [treeviewLearningId, setTreeviewLearningId] = React.useState(0);
  // const [treeviewLearningTitle, setTreeviewLearningTitle] = React.useState("");
  const [selftestOptionsObjectiveId, setSelftestOptionsObjectiveId] = React.useState(0);
  const [selftestOptionsObjectiveTitle, setSelftestOptionsObjectiveTitle] = React.useState("");
  const [selftestOptionsSubjectiveId, setSelftestOptionsSubjectiveId] = React.useState(0);
  const [selftestOptionsSubjectiveTitle, setSelftestOptionsSubjectiveTitle] = React.useState("");
  const [objectiveExamLimitId, setObjectiveExamLimitId] = React.useState(0);
  const [objectiveExamLimitTitle, setObjectiveExamLimitTitle] = React.useState("");
  const [subjectiveExamLimitId, setSubjectiveExamLimitId] = React.useState(0);
  const [subjectiveExamLimitTitle, setSubjectiveExamLimitTitle] = React.useState("");
  const [objectiveQueTypeTempId, setObjectiveQueTypeTempId] = React.useState(0);
  const [objectiveQueTypeTempTitle, setObjectiveQueTypeTempTitle] = React.useState("");
  const [subjectiveQueTypeTempId, setSubjectiveQueTypeTempId] = React.useState(0);
  const [subjectiveQueTypeTempTitle, setSubjectiveQueTypeTempTitle] = React.useState("");
  const [mocktestTemplateId, setMocktestTemplateId] = React.useState(0);
  const [mocktestTemplateTitle, setMocktestTemplateTitle] = React.useState("");
  const [dynamicMockTempId, setDynamicMockTempId] = React.useState(0);
  const [dynamicMockTempTitle, setDynamicMockTempTitle] = React.useState("");
  const [topictestTemplateId, setTopictestTemplateId] = React.useState(0);
  const [topictestTemplateTitle, setTopictestTemplateTitle] = React.useState("");
  const [classTopicTestTemplateId, setClassTopicTestTemplateId] = React.useState(0);
  const [classTopicTestTemplateTitle, setClassTopicTestTemplateTitle] = React.useState("");
  const [classMockTestTemplateId, setClassMockTestTemplateId] = React.useState(0);
  const [classMockTestTemplateTitle, setClassMockTestTemplateTitle] = React.useState("");

  const [contentLimitId, setContentLimitId] = React.useState(0);
  const [contentLimitTitle, setContentLimitTitle] = React.useState("");

  const [checkedDashboard, setCheckedDashboard] = React.useState(true);
  const [checkedReport, setCheckedReport] = React.useState(true);
  const [checkedStudyMaterial, setCheckedStudyMaterial] = React.useState(true);
  const [checkedSelfTest, setCheckedSelfTest] = React.useState(true);
  const [checkedTopicTest, setCheckedTopicTest] = React.useState(true);
  const [checkedMockTest, setCheckedMockTest] = React.useState(true);
  const [checkedDynamicMockTest, setCheckedDynamicMockTest] = React.useState(true);
  //const [checkedClassTest, setCheckedClassTest] = React.useState(true);
  const [checkedTeacherHelp, setCheckedTeacherHelp] = React.useState(true);
  const [checkedTonyHelp, setCheckedTonyHelp] = React.useState(true);

  const [treeviewTemplateList, setTreeviewTemplateList] = React.useState([]);
  const [selftestOptionsObjectiveList, setSelftestOptionsObjectiveList] = React.useState([]);
  const [selftestOptionsSubjectiveList, setSelftestOptionsSubjectiveList] = React.useState([]);
  const [objectiveExamLimitList, setObjectiveExamLimitList] = React.useState([]);
  const [subjectiveExamLimitList, setSubjectiveExamLimitList] = React.useState([]);
  const [objectiveQueTypeTempList, setObjectiveQueTypeTempList] = React.useState([]);
  const [subjectiveQueTypeTempList, setSubjectiveQueTypeTempList] = React.useState([]);
  const [mocktestTemplateList, setMocktestTemplateList] = React.useState([]);
  const [topictestTemplateList, setTopictestTemplateList] = React.useState([]);

  const [contentLimitList, setContentLimitList] = React.useState([]);
  
  const [benchmark, setBenchmark] = React.useState(0);
  //const [contentTypes, setContentTypes] = React.useState([]);
  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  
  React.useEffect(() => {	

    setSaveLoading(false);

    if(open && userObj){
      getApiData();
    }

    if(open && props.dataObj && props.dataObj.autoId){	
      setTemplateTitle(props.dataObj.templateTitle);
      setTreeviewTemplateId(props.dataObj.treeviewTemplateId);
      setTreeviewTemplateTitle(props.dataObj.treeviewTemplateTitle);
      // setTreeviewLearningId(props.dataObj.treeviewLearningId);
      // setTreeviewLearningTitle(props.dataObj.treeviewLearningTitle);
      setSelftestOptionsObjectiveId(props.dataObj.selftestOptionsObjectiveId);
      setSelftestOptionsObjectiveTitle(props.dataObj.selftestOptionsObjectiveTitle);
      setSelftestOptionsSubjectiveId(props.dataObj.selftestOptionsSubjectiveId);
      setSelftestOptionsSubjectiveTitle(props.dataObj.selftestOptionsSubjectiveTitle);

      setObjectiveExamLimitId(props.dataObj.objectiveExamLimitId);
      setObjectiveExamLimitTitle(props.dataObj.objectiveExamLimitTitle);
      setSubjectiveExamLimitId(props.dataObj.subjectiveExamLimitId);
      setSubjectiveExamLimitTitle(props.dataObj.subjectiveExamLimitTitle);

      setObjectiveQueTypeTempId(props.dataObj.objectiveQueTypeTempId);
      setObjectiveQueTypeTempTitle(props.dataObj.objectiveQueTypeTempTitle);
      setSubjectiveQueTypeTempId(props.dataObj.subjectiveQueTypeTempId);
      setSubjectiveQueTypeTempTitle(props.dataObj.subjectiveQueTypeTempTitle);
      setMocktestTemplateId(props.dataObj.mocktestTemplateId);
      setMocktestTemplateTitle(props.dataObj.mocktestTemplateTitle);
      setDynamicMockTempId(props.dataObj.dynamicMockTempId);
      setDynamicMockTempTitle(props.dataObj.dynamicMockTempTitle);
      setTopictestTemplateId(props.dataObj.topictestTemplateId);
      setTopictestTemplateTitle(props.dataObj.topictestTemplateTitle);

      setClassTopicTestTemplateId(props.dataObj.classTopicTestTemplateId);
      setClassTopicTestTemplateTitle(props.dataObj.classTopicTestTemplateTitle);

      setClassMockTestTemplateId(props.dataObj.classMockTestTemplateId);
      setClassMockTestTemplateTitle(props.dataObj.classMockTestTemplateTitle);

      setContentLimitId(props.dataObj.contentLimitId);
      setContentLimitTitle(props.dataObj.contentLimitTitle);

      setBenchmark(props.dataObj.benchmark);
    
      if(props.dataObj.dashboardOption===1){
        setCheckedDashboard(true);
      }else{
        setCheckedDashboard(false);
      }

      if(props.dataObj.reportOption===1){
        setCheckedReport(true);
      }else{
        setCheckedReport(false);
      }

      if(props.dataObj.studyMaterialOption===1){
        setCheckedStudyMaterial(true);
      }else{
        setCheckedStudyMaterial(false);
      }

      if(props.dataObj.selfTestOption===1){
        setCheckedSelfTest(true);
      }else{
        setCheckedSelfTest(false);
      }
      
      if(props.dataObj.topicTestOption===1){
        setCheckedTopicTest(true);
      }else{
        setCheckedTopicTest(false);
      }
     
      if(props.dataObj.mockTestOption===1){
        setCheckedMockTest(true);
      }else{
        setCheckedMockTest(false);
      }

      if(props.dataObj.dynamicMockTestOption===1){
        setCheckedDynamicMockTest(true);
      }else{
        setCheckedDynamicMockTest(false);
      }
      
      // if(props.dataObj.classTestOption===1){
      //   setCheckedClassTest(true);
      // }else{
      //   setCheckedClassTest(false);
      // }
      
      if(props.dataObj.teacherHelpOption===1){
        setCheckedTeacherHelp(true);
      }else{
        setCheckedTeacherHelp(false);
      }
      
      // if(props.dataObj.contentTypes){
      //   setContentTypes(props.dataObj.contentTypes.split(','));
      // }

    }else{
      setTemplateTitle("");
      setTreeviewTemplateId(0);
      setTreeviewTemplateTitle("");
      // setTreeviewLearningId(0);
      // setTreeviewLearningTitle("");
      setSelftestOptionsObjectiveId(0);
      setSelftestOptionsObjectiveTitle("");
      setSelftestOptionsSubjectiveId(0);
      setSelftestOptionsSubjectiveTitle("");
      setObjectiveExamLimitId(0);
      setObjectiveExamLimitTitle("");
      setSubjectiveExamLimitId(0);
      setSubjectiveExamLimitTitle("");
      setObjectiveQueTypeTempId(0);
      setObjectiveQueTypeTempTitle("");
      setSubjectiveQueTypeTempId(0);
      setSubjectiveQueTypeTempTitle("");
      setMocktestTemplateId(0);
      setMocktestTemplateTitle("");
      setDynamicMockTempId(0);
      setDynamicMockTempTitle("");
      setTopictestTemplateId(0);
      setTopictestTemplateTitle("");

      setClassTopicTestTemplateId(0);
      setClassTopicTestTemplateTitle("");

      setClassMockTestTemplateId(0);
      setClassMockTestTemplateTitle("");

      setContentLimitId(0);
      setContentLimitTitle("");
      
      setCheckedDashboard(true);
      setCheckedReport(true);
      setCheckedStudyMaterial(true);
      setCheckedSelfTest(true);
      setCheckedTopicTest(true);
      setCheckedMockTest(true);
      setCheckedDynamicMockTest(true);
      //setCheckedClassTest(true);
      setCheckedTeacherHelp(true);
      ///setContentTypes([]);
      setBenchmark(0);

    }
	}, [props.dataObj,open]);


  async function getApiData(){
    let axiosHeader = {
      headers: {
        'Content-Type': 'multipart/mixed',
        'loginId': userObj.loginId,
        'token': userObj.token,
        'device': 'web'					
      }
    };
    let endpoints1 = env.API_URL+"/topic-service/read/topics-templates?sortby=templateName&maxRows=50000";
    let endpoints2 = env.API_URL+"/exams/read/selftest-options-objective?sortby=templateTitle&maxRows=50000";
    let endpoints3 = env.API_URL+"/exams/read/selftest-options-subjective?sortby=templateTitle&maxRows=50000";
    let endpoints4 = env.API_URL+"/exams/read/exam-limits-objective?sortby=templateTitle&maxRows=50000";
    let endpoints5 = env.API_URL+"/exams/read/exam-limits-subjective?sortby=templateTitle&maxRows=50000";
    let endpoints6 = env.API_URL+"/exams/read/qt-templates?sortby=templateTitle&maxRows=50000";
    let endpoints7 = env.API_URL+"/exams/read/mocktest-templates?sortby=templateTitle&maxRows=50000";
    let endpoints8 = env.API_URL+"/exams/read/topictest-templates?sortby=templateTitle&maxRows=50000";
    let endpoints9 = env.API_URL+"/exams/read/content-limits?sortby=templateTitle&maxRows=50000";

    const axiosrequest1 = axios.get(endpoints1,axiosHeader);
    const axiosrequest2 = axios.get(endpoints2,axiosHeader);
    const axiosrequest3 = axios.get(endpoints3,axiosHeader);
    const axiosrequest4 = axios.get(endpoints4,axiosHeader);
    const axiosrequest5 = axios.get(endpoints5,axiosHeader);
    const axiosrequest6 = axios.get(endpoints6,axiosHeader);
    const axiosrequest7 = axios.get(endpoints7,axiosHeader);
    const axiosrequest8 = axios.get(endpoints8,axiosHeader);
    const axiosrequest9 = axios.get(endpoints9,axiosHeader);

    await axios.all([axiosrequest1, axiosrequest2, axiosrequest3, axiosrequest4, axiosrequest5, axiosrequest6, axiosrequest7, axiosrequest8, axiosrequest9]).then(axios.spread(function(res1, res2, res3, res4, res5, res6, res7, res8, res9) {
      setTreeviewTemplateList(res1.data.obj.list);
      setSelftestOptionsObjectiveList(res2.data.obj.list);
      setSelftestOptionsSubjectiveList(res3.data.obj.list);
      setObjectiveExamLimitList(res4.data.obj.list);
      setSubjectiveExamLimitList(res5.data.obj.list);
      setObjectiveQueTypeTempList(res6.data.obj.list);
      setSubjectiveQueTypeTempList(res6.data.obj.list);
      setMocktestTemplateList(res7.data.obj.list);
      setTopictestTemplateList(res8.data.obj.list);
      setContentLimitList(res9.data.obj.list);

    }));
  }


	function saveData(){    
    
    if(!templateTitle){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter title");			
      return false;
    }
    if(!treeviewTemplateId){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select treeview");			
      return false;
    }
    if(!objectiveExamLimitId && !subjectiveExamLimitId){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Objective/Subjective Assessment Limit");			
      return false;
    }  

    
		if(templateTitle && templateTitle.length>1){ 
      setSaveLoading(true);

			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'	
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      } 
      data.append('templateTitle', templateTitle);

      if(benchmark && benchmark>0){
        data.append('benchmark', benchmark);
      }else{
        data.append('benchmark', 0);
      }

      data.append('treeviewTemplateTitle', treeviewTemplateTitle);
      if(treeviewTemplateId && treeviewTemplateId>0){
        data.append('treeviewTemplateId', treeviewTemplateId);
      }else{
        data.append('treeviewTemplateId', 0);
      }

      // data.append('treeviewLearningTitle', treeviewLearningTitle);
      // if(treeviewLearningId && treeviewLearningId>0){
      //   data.append('treeviewLearningId', treeviewLearningId);
      // }else{
      //   data.append('treeviewLearningId', 0);
      // }

      data.append('selftestOptionsObjectiveTitle', selftestOptionsObjectiveTitle);
      if(selftestOptionsObjectiveId && selftestOptionsObjectiveId>0){
        data.append('selftestOptionsObjectiveId', selftestOptionsObjectiveId);
      }else{
        data.append('selftestOptionsObjectiveId', 0);
      }

      data.append('selftestOptionsSubjectiveTitle', selftestOptionsSubjectiveTitle);
      if(selftestOptionsSubjectiveId && selftestOptionsSubjectiveId>0){
        data.append('selftestOptionsSubjectiveId', selftestOptionsSubjectiveId);
      }else{
        data.append('selftestOptionsSubjectiveId', 0);
      }

      data.append('objectiveExamLimitTitle', objectiveExamLimitTitle);
      if(objectiveExamLimitId && objectiveExamLimitId>0){
        data.append('objectiveExamLimitId', objectiveExamLimitId);
      }else{
        data.append('objectiveExamLimitId', 0);
      }

      data.append('subjectiveExamLimitTitle', subjectiveExamLimitTitle);
      if(subjectiveExamLimitId && subjectiveExamLimitId>0){
        data.append('subjectiveExamLimitId', subjectiveExamLimitId);
      }else{
        data.append('subjectiveExamLimitId', 0);
      }

      data.append('objectiveQueTypeTempTitle', objectiveQueTypeTempTitle);
      if(objectiveQueTypeTempId && objectiveQueTypeTempId>0){
        data.append('objectiveQueTypeTempId', objectiveQueTypeTempId);
      }else{
        data.append('objectiveQueTypeTempId', 0);
      }

      data.append('subjectiveQueTypeTempTitle', subjectiveQueTypeTempTitle);
      if(subjectiveQueTypeTempId && subjectiveQueTypeTempId>0){
        data.append('subjectiveQueTypeTempId', subjectiveQueTypeTempId);
      }else{
        data.append('subjectiveQueTypeTempId', 0);
      }

      data.append('mocktestTemplateTitle', mocktestTemplateTitle);
      if(mocktestTemplateId && mocktestTemplateId>0){
        data.append('mocktestTemplateId', mocktestTemplateId);
      }else{
        data.append('mocktestTemplateId', 0);
      }

      data.append('dynamicMockTempTitle', dynamicMockTempTitle);
      if(dynamicMockTempId && dynamicMockTempId>0){
        data.append('dynamicMockTempId', dynamicMockTempId);
      }else{
        data.append('dynamicMockTempId', 0);
      }

      data.append('topictestTemplateTitle', topictestTemplateTitle);
      if(topictestTemplateId && topictestTemplateId>0){
        data.append('topictestTemplateId', topictestTemplateId);
      }else{
        data.append('topictestTemplateId', 0);
      }

      data.append('classTopicTestTemplateTitle', classTopicTestTemplateTitle);
      if(classTopicTestTemplateId && classTopicTestTemplateId>0){
        data.append('classTopicTestTemplateId', classTopicTestTemplateId);
      }else{
        data.append('classTopicTestTemplateId', 0);
      }

      data.append('classMockTestTemplateTitle', classMockTestTemplateTitle);
      if(classMockTestTemplateId && classMockTestTemplateId>0){
        data.append('classMockTestTemplateId', classMockTestTemplateId);
      }else{
        data.append('classMockTestTemplateId', 0);
      }

      data.append('contentLimitTitle', contentLimitTitle);
      if(contentLimitId && contentLimitId>0){
        data.append('contentLimitId', contentLimitId);
      }else{
        data.append('contentLimitId', 0);
      }      

      if(checkedDashboard===true){
        data.append('dashboardOption', 1);
      }else{
        data.append('dashboardOption', 0);
      }

      if(checkedReport===true){
        data.append('reportOption', 1);
      }else{
        data.append('reportOption', 0);
      }

      if(checkedStudyMaterial===true){
        data.append('studyMaterialOption', 1);
      }else{
        data.append('studyMaterialOption', 0);
      }

      if(checkedSelfTest===true){
        data.append('selfTestOption', 1);
      }else{
        data.append('selfTestOption', 0);
      }

      if(checkedTopicTest===true){
        data.append('topicTestOption', 1);
      }else{
        data.append('topicTestOption', 0);
      }

      if(checkedMockTest===true){
        data.append('mockTestOption', 1);
      }else{
        data.append('mockTestOption', 0);
      }

      if(checkedDynamicMockTest===true){
        data.append('dynamicMockTestOption', 1);
      }else{
        data.append('dynamicMockTestOption', 0);
      }
      
      data.append('classTestOption', 0);
      // if(checkedClassTest===true){
      //   data.append('classTestOption', 1);
      // }else{
      //   data.append('classTestOption', 0);
      // }
      
      if(checkedTeacherHelp===true){
        data.append('teacherHelpOption', 1);
      }else{
        data.append('teacherHelpOption', 0);
      }

      if(checkedTonyHelp===true){
        data.append('tonyHelpOption', 1);
      }else{
        data.append('tonyHelpOption', 0);
      }

      // if(contentTypes && contentTypes.length>0){
      //   data.append('studyMaterialContentTypes', contentTypes.join(','));
      // }else{
      //   data.append('studyMaterialContentTypes', '');
      // }
      
      let apiURL='/exams/create/exam-templates';
      let myMessage="Template name has been created.";
      if(!props.clone && props.dataObj && props.dataObj.autoId){
          apiURL='/exams/update/exam-templates';
          myMessage="Template name has been updated.";
      }
             
			axios.post(env.API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage(myMessage);
          props.updatedList(response.data.obj.list);	
					return false;
        }else if(response.data.responseTxt==="alreadyexistserror"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("This template name was created earlier. Enter another template name");
            return false;  					
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This template could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})	
		}		
	}

  function handleTreeview(obj){
    if(obj){
      setTreeviewTemplateId(obj.autoId);
      setTreeviewTemplateTitle(obj.templateName);
    }else{
      setTreeviewTemplateId(0);
      setTreeviewTemplateTitle("");
    }
  }

  // function handleTreeview(val){
  //   let valArr = val.split('#');
  //   setTreeviewTemplateId(valArr[0]);
  //   setTreeviewTemplateTitle(valArr[1]);
  // }

  // function handleTreeviewLearning(val){
  //   let valArr = val.split('#');
  //   setTreeviewLearningId(valArr[0]);
  //   setTreeviewLearningTitle(valArr[1]);
  // }
  function handleSelftestOptionsObjective(obj){
    if(obj){
      setSelftestOptionsObjectiveId(obj.autoId);
      setSelftestOptionsObjectiveTitle(obj.templateTitle);
    }else{
      setSelftestOptionsObjectiveId(0);
      setSelftestOptionsObjectiveTitle('');
    }
  }
  function handleSelftestOptionsSubjective(obj){
    if(obj){
      setSelftestOptionsSubjectiveId(obj.autoId);
      setSelftestOptionsSubjectiveTitle(obj.templateTitle);
    }else{
      setSelftestOptionsSubjectiveId(0);
      setSelftestOptionsSubjectiveTitle('');
    }
  }
  function handleObjectiveExamLimit(val){
    let valArr = val.split('#');
    setObjectiveExamLimitId(valArr[0]);
    setObjectiveExamLimitTitle(valArr[1]);
  }
  function handleSubjectiveExamLimit(val){
    let valArr = val.split('#');
    setSubjectiveExamLimitId(valArr[0]);
    setSubjectiveExamLimitTitle(valArr[1]);
  }
  function handleContentLimit(val){
    let valArr = val.split('#');
    setContentLimitId(valArr[0]);
    setContentLimitTitle(valArr[1]);
  }
  function handleObjectiveQueTypeTemp(obj){
    if(obj){
      setObjectiveQueTypeTempId(obj.autoId);
      setObjectiveQueTypeTempTitle(obj.templateTitle);
    }else{
      setObjectiveQueTypeTempId(0);
      setObjectiveQueTypeTempTitle('');
    }
  }
  function handleSubjectiveQueTypeTemp(obj){
    if(obj){
      setSubjectiveQueTypeTempId(obj.autoId);
      setSubjectiveQueTypeTempTitle(obj.templateTitle);
    }else{
      setSubjectiveQueTypeTempId(0);
      setSubjectiveQueTypeTempTitle('');
    }
  }
  function handleMocktestTemplate(obj){
    if(obj){
      setMocktestTemplateId(obj.autoId);
      setMocktestTemplateTitle(obj.templateTitle);
    }else{
      setMocktestTemplateId(0);
      setMocktestTemplateTitle('');
    }
  }
  function handleDynamicMocktestTemplate(obj){
    if(obj){
      setDynamicMockTempId(obj.autoId);
      setDynamicMockTempTitle(obj.templateTitle);
    }else{
      setDynamicMockTempId(0);
      setDynamicMockTempTitle('');
    }
  }
  function handleTopictestTemplate(obj){
    if(obj){
      setTopictestTemplateId(obj.autoId);
      setTopictestTemplateTitle(obj.templateTitle);
    }else{
      setTopictestTemplateId(0);
      setTopictestTemplateTitle('');
    }
  }
  function handleClassTopicTestTemplate(obj){
    if(obj){
      setClassTopicTestTemplateId(obj.autoId);
      setClassTopicTestTemplateTitle(obj.templateTitle);
    }else{
      setClassTopicTestTemplateId(0);
      setClassTopicTestTemplateTitle('');
    }
  }

  function handleClassMockTestTemplate(obj){
    if(obj){
      setClassMockTestTemplateId(obj.autoId);
      setClassMockTestTemplateTitle(obj.templateTitle);
    }else{
      setClassMockTestTemplateId(0);
      setClassMockTestTemplateTitle('');
    }
  }

  // function selectedContentTypes(arr) {
  //   setContentTypes(arr);
  // }
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.clone?<>Clone</>:(props.dataObj && props.dataObj.autoId>0)?<>Edit</>:<>New</>} Course Template</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Template Title</td>
                            <td>
                            <TextField onChange={event => setTemplateTitle(event.target.value)} value={templateTitle} placeholder={'Title'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} style={{textAlign:'center'}}>
                                  <h3>Treeview</h3>                                  
                                </Grid>
                              </Grid>
                            <Grid container spacing={2}>
								                <Grid item xs={6}>
                                  Treeview (Self-Test & Study Material)
                                </Grid>
                                <Grid item xs={6}>
                                    {(treeviewTemplateList && treeviewTemplateList.length>0)?  
                                    <AutocompleteTreeviewTemp options={treeviewTemplateList} defaultValue={treeviewTemplateTitle} handleSelect={handleTreeview} />
                                    :<Select 
                                      fullWidth
                                      labelId="select-class-label"
                                      id="select-class"
                                      variant="standard"
                                    >
                                      <MenuItem></MenuItem>
                                     </Select>}                            
                                </Grid>
                              </Grid>

                              <Grid container spacing={2}>
                                <Grid item xs={12} style={{textAlign:'center'}}>
                                  <h3>Self Test</h3>                                  
                                </Grid>
                              </Grid>  
                              <Grid container spacing={2}>
								                <Grid item xs={6}>
                                  Objective Selftest Options
                                </Grid>
                                <Grid item xs={6}>
                                  {(selftestOptionsObjectiveList && selftestOptionsObjectiveList.length>0)?  
                                    <AutocompleteTT options={selftestOptionsObjectiveList} defaultValue={selftestOptionsObjectiveTitle} handleSelect={handleSelftestOptionsObjective} />
                                  :<Select 
                                    fullWidth
                                    labelId="select-class-label"
                                    id="select-class"
                                    variant="standard"
                                  >
                                    <MenuItem></MenuItem>
                                 </Select>}
                                </Grid>
                              </Grid> 
                              <Grid container spacing={2}>
								                <Grid item xs={6}>
                                  Subjective Selftest Options
                                </Grid>
                                <Grid item xs={6}>
                                  {(selftestOptionsSubjectiveList && selftestOptionsSubjectiveList.length>0)?  
                                    <AutocompleteTT options={selftestOptionsSubjectiveList} defaultValue={selftestOptionsSubjectiveTitle} handleSelect={handleSelftestOptionsSubjective} />
                                  :<Select 
                                    fullWidth
                                    labelId="select-class-label"
                                    id="select-class"
                                    variant="standard"
                                    >
                                    <MenuItem></MenuItem>
                                  </Select>}
                                </Grid>
                              </Grid>  
                              <Grid container spacing={2}>
								                <Grid item xs={6}>
                                  Objective Question Type List
                                </Grid>
                                <Grid item xs={6}>
                                  {(objectiveQueTypeTempList && objectiveQueTypeTempList.length>0)?  
                                    <AutocompleteTT options={objectiveQueTypeTempList} defaultValue={objectiveQueTypeTempTitle} handleSelect={handleObjectiveQueTypeTemp} />
                                  :<Select 
                                    fullWidth
                                    labelId="select-class-label"
                                    id="select-class"
                                    variant="standard"
                                    >
                                    <MenuItem></MenuItem>
                                  </Select>}
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
								                <Grid item xs={6}>
                                  Subjective Question Type List
                                </Grid>
                                <Grid item xs={6}>
                                  {(subjectiveQueTypeTempList && subjectiveQueTypeTempList.length>0)?  
                                    <AutocompleteTT options={subjectiveQueTypeTempList} defaultValue={subjectiveQueTypeTempTitle} handleSelect={handleSubjectiveQueTypeTemp} />
                                  :<Select 
                                    fullWidth
                                    labelId="select-class-label"
                                    id="select-class"
                                    variant="standard"
                                    >
                                    <MenuItem></MenuItem>
                                  </Select>}
                                </Grid>
                              </Grid>
                            </td>                            
                        </tr>
                        {/* <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2}>
                              <Grid container spacing={2}>
                                <Grid item xs={12} style={{textAlign:'center'}}>
                                  <h3>Study Material</h3>
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
								                <Grid item xs={6}>
                                  Display in Navigation Menu
                                </Grid>
                                <Grid item xs={6}>
                                  <FormControlLabel
                                    label="Active Study Material"
                                    control={<Checkbox checked={checkedStudyMaterial} onChange={(event) => {setCheckedStudyMaterial(event.target.checked)}} />}
                                  />
                                </Grid>
                              </Grid> 
                              <Grid container spacing={2}>
								                <Grid item xs={6}>
                                  Treeview
                                </Grid>
                                <Grid item xs={6}>
                                  <Select 
                                      fullWidth
                                      labelId="select-class-label"
                                      id="select-class"
                                      value={treeviewLearningId+'#'+treeviewLearningTitle}									
                                      onChange={event => handleTreeviewLearning(event.target.value)}
                                      variant="standard"
                                    >
                                        <MenuItem value={'0#'} >Select</MenuItem>
                                        {(treeviewTemplateList && treeviewTemplateList.length>0)?treeviewTemplateList.map((row,i)=>(
                                          <MenuItem key={'tchr'+i} value={row.autoId+'#'+row.templateName}>{row.templateName}</MenuItem>
                                        )):null}                
                                  </Select>
                                </Grid>
                              </Grid>                              

                            </td>                            
                        </tr> */}
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2}>
                              <Grid container spacing={2}>
                                <Grid item xs={12} style={{textAlign:'center'}}>
                                  <h3>Mock Test</h3>
                                </Grid>
                              </Grid>                              
                              <Grid container spacing={2}>
								                <Grid item xs={6}>
                                  Mock Test Template
                                </Grid>
                                <Grid item xs={6}>
                                  {(mocktestTemplateList && mocktestTemplateList.length>0)?  
                                    <AutocompleteTT options={mocktestTemplateList} defaultValue={mocktestTemplateTitle} handleSelect={handleMocktestTemplate} />
                                  :<Select 
                                    fullWidth
                                    labelId="select-class-label"
                                    id="select-class"
                                    variant="standard"
                                    >
                                    <MenuItem></MenuItem>
                                  </Select>}
                                </Grid>
                              </Grid>

                             </td>
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2}>
                              <Grid container spacing={2}>
                                <Grid item xs={12} style={{textAlign:'center'}}>
                                  <h3>Model Test</h3>
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
								                <Grid item xs={6}>
                                Model Test Template
                                {/* Dynamic Mock Test */}
                                </Grid>
                                <Grid item xs={6}>
                                  {(mocktestTemplateList && mocktestTemplateList.length>0)?  
                                    <AutocompleteTT options={mocktestTemplateList} defaultValue={dynamicMockTempTitle} handleSelect={handleDynamicMocktestTemplate} />
                                  :<Select 
                                    fullWidth
                                    labelId="select-class-label"
                                    id="select-class"
                                    variant="standard"
                                    >
                                    <MenuItem></MenuItem>
                                  </Select>}
                                </Grid>
                              </Grid>
                              

                             </td>
                        </tr>

                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2}>
                              <Grid container spacing={2}>
                                <Grid item xs={12} style={{textAlign:'center'}}>
                                  <h3>Topic Test</h3>
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
								                <Grid item xs={6}>
                                  Topic Test Template
                                </Grid>
                                <Grid item xs={6}>
                                  {(topictestTemplateList && topictestTemplateList.length>0)?  
                                    <AutocompleteTT options={topictestTemplateList} defaultValue={topictestTemplateTitle} handleSelect={handleTopictestTemplate} />
                                  :<Select 
                                    fullWidth
                                    labelId="select-class-label"
                                    id="select-class"
                                    variant="standard"
                                    >
                                    <MenuItem></MenuItem>
                                  </Select>}
                                </Grid>
                              </Grid>
                                           
                            </td>                           
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2}>
                              <Grid container spacing={2}>
                                <Grid item xs={12} style={{textAlign:'center'}}>
                                  <h3>Class Test</h3>
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
								                <Grid item xs={6}>
                                Class Topic Test Template
                                </Grid>
                                <Grid item xs={6}>
                                  {(topictestTemplateList && topictestTemplateList.length>0)?  
                                    <AutocompleteTT options={topictestTemplateList} defaultValue={classTopicTestTemplateTitle} handleSelect={handleClassTopicTestTemplate} />
                                  :<Select 
                                    fullWidth
                                    labelId="select-class-label"
                                    id="select-class"
                                    variant="standard"
                                    >
                                    <MenuItem></MenuItem>
                                  </Select>}
                                </Grid>
                                <Grid item xs={6}>
                                  Class Mock Test Template
                                </Grid>
                                <Grid item xs={6}>
                                  {(mocktestTemplateList && mocktestTemplateList.length>0)?  
                                    <AutocompleteTT options={mocktestTemplateList} defaultValue={classMockTestTemplateTitle} handleSelect={handleClassMockTestTemplate} />
                                  :<Select 
                                    fullWidth
                                    labelId="select-class-label"
                                    id="select-class"
                                    variant="standard"
                                    >
                                    <MenuItem></MenuItem>
                                  </Select>}
                                </Grid>

                              </Grid>

                            </td>
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Objective Assessment Limit</td>
                            <td>
                              <Select 
                                  fullWidth
                                  labelId="select-class-label"
                                  id="select-class"
                                  value={objectiveExamLimitId+'#'+objectiveExamLimitTitle}									
                                  onChange={event => handleObjectiveExamLimit(event.target.value)}
                                  variant="standard"
                                >
                                    <MenuItem value={'0#'} >Select</MenuItem>
                                    {(objectiveExamLimitList && objectiveExamLimitList.length>0)?objectiveExamLimitList.map((row,i)=>(
                                      <MenuItem key={'tchr'+i} value={row.autoId+'#'+row.templateTitle}>{row.templateTitle}</MenuItem>
                                    )):null} 
                              </Select>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Subjective Assessment Limit</td>
                            <td>
                              <Select 
                                  fullWidth
                                  labelId="select-class-label"
                                  id="select-class"
                                  value={subjectiveExamLimitId+'#'+subjectiveExamLimitTitle}									
                                  onChange={event => handleSubjectiveExamLimit(event.target.value)}
                                  variant="standard"
                                >
                                    <MenuItem value={'0#'} >Select</MenuItem>
                                    {(subjectiveExamLimitList && subjectiveExamLimitList.length>0)?subjectiveExamLimitList.map((row,i)=>(
                                      <MenuItem key={'tchr'+i} value={row.autoId+'#'+row.templateTitle}>{row.templateTitle}</MenuItem>
                                    )):null} 
                              </Select>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Content Limit</td>
                            <td>
                              <Select 
                                  fullWidth
                                  labelId="select-class-label"
                                  id="select-class"
                                  value={contentLimitId+'#'+contentLimitTitle}									
                                  onChange={event => handleContentLimit(event.target.value)}
                                  variant="standard"
                                >
                                    <MenuItem value={'0#'} >Select</MenuItem>
                                    {(contentLimitList && contentLimitList.length>0)?contentLimitList.map((row,i)=>(
                                      <MenuItem key={'tchr'+i} value={row.autoId+'#'+row.templateTitle}>{row.templateTitle}</MenuItem>
                                    )):null} 
                              </Select>
                            </td>                            
                        </tr>

                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Display Navigation Menu</td>
                            <td>
                              <FormControlLabel
                                label="Dashboard"
                                control={<Checkbox checked={checkedDashboard} onChange={(event) => {setCheckedDashboard(event.target.checked)}} />}
                              />
                              <FormControlLabel
                                    label="Selftest"
                                    control={<Checkbox checked={checkedSelfTest} onChange={(event) => {setCheckedSelfTest(event.target.checked)}} />}
                              />
                              <FormControlLabel
                                    label="Mock Test"
                                    control={<Checkbox checked={checkedMockTest} onChange={(event) => {setCheckedMockTest(event.target.checked)}} />}
                              />
                              <FormControlLabel
                                    label="Model Test"
                                    control={<Checkbox checked={checkedDynamicMockTest} onChange={(event) => {setCheckedDynamicMockTest(event.target.checked)}} />}
                              />
                              <FormControlLabel
                                    label="Topic Test"
                                    control={<Checkbox checked={checkedTopicTest} onChange={(event) => {setCheckedTopicTest(event.target.checked)}} />}
                              />
                              {/* <FormControlLabel
                                    label="Class Test"
                                    control={<Checkbox checked={/checkedClassTest} onChange={(event) => {setCheckedClassTest(event.target.checked)}} />}
                              /> */}
                              <FormControlLabel
                                    label="Study Material"
                                    control={<Checkbox checked={checkedStudyMaterial} onChange={(event) => {setCheckedStudyMaterial(event.target.checked)}} />}
                              />
                              <FormControlLabel
                                label="Reports"
                                control={<Checkbox checked={checkedReport} onChange={(event) => {setCheckedReport(event.target.checked)}} />}
                              />
                              <FormControlLabel
                                label="Teacher Help"
                                control={<Checkbox checked={checkedTeacherHelp} onChange={(event) => {setCheckedTeacherHelp(event.target.checked)}} />}
                              />
                              <FormControlLabel
                                label="Tony Help"
                                control={<Checkbox checked={checkedTonyHelp} onChange={(event) => {setCheckedTonyHelp(event.target.checked)}} />}
                              />
                                
                            </td>                            
                        </tr>
                        {/* <tr style={{backgroundColor:'#FFFFFF'}} >
                          <td>Study Material Content Types</td>
                          <td>
                            <TagsOptions defaultValues={contentTypes} selectedTags={selectedContentTypes} options={[{title:'Video'},{title:'PDF'},{title:'PPT'},{title:'Text'}]} label='Select' freesolo={false}  />
                          </td>
                        </tr> */}
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Benchmark</td>
                            <td>
                            <TextField onChange={event => setBenchmark(event.target.value)} value={benchmark} placeholder={'Benchmark'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          {saveLoading?
                          <LoadingButton loading={saveLoading} loadingPosition='start' startIcon={<div style={{marginRight:15}}></div>} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Saving...</LoadingButton>
					    	          :
                          <Button onClick={() => {saveData()}} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Save</Button>
                          }
                      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;